<div [formGroup]="form" [style.grid-area]="setGridPosition(config.grid)">
  @if (config.type === customFormElements.hidden) {
    <hidden [group]="form" [config]="config"> </hidden>
  }

  @if (config.type === customFormElements.brandColor) {
    <brand-color [config]="config" [group]="form" [direction]="direction">
    </brand-color>
  }

  @if (
    config.type === customFormElements.systemIcon ||
    config.type === customFormElements.productIcon
  ) {
    <system-icon
      [config]="config"
      [group]="form"
      [direction]="direction"
      [set]="
        config.type === customFormElements.systemIcon ? 'system' : 'product'
      "
    >
    </system-icon>
  }

  @if (config.type === customFormElements.termsAndConditions) {
    <terms-and-conditions [config]="config" [group]="form">
    </terms-and-conditions>
  }

  @if (config.type === customFormElements.autopay) {
    <autopay [form]="form" [config]="config"> </autopay>
  }

  @if (config.type === customFormElements.passwords) {
    <passwords [config]="config" [group]="form"> </passwords>
  }

  @if (config.type === customFormElements.whoseCovered) {
    <whose-covered
      (formCreated)="formCreated.emit($event)"
      [group]="form"
      [direction]="direction"
      [config]="config"
    >
    </whose-covered>
  }

  @if (config.type === customFormElements.industryGroup) {
    <industries
      [formControlName]="config.prop"
      [direction]="direction"
      [config]="config"
    >
    </industries>
  }

  @if (config.type === customFormElements.basicAddress) {
    <basic-address [direction]="direction" [config]="config" [group]="form">
    </basic-address>
  }

  @if (config.type === customFormElements.companyAddress) {
    <company-address
      (addressValidationChange)="updateAddressForm($event)"
      [formControlName]="config.prop"
      [direction]="direction"
      [config]="config"
    >
    </company-address>
  }

  @if (config.type === customFormElements.officeHours) {
    <office-hours [direction]="direction" [config]="config" [group]="form">
    </office-hours>
  }

  @if (config.type === customFormElements.formArray) {
    <form-array
      [group]="form"
      [formArrayConfig]="config"
      [direction]="direction"
    >
    </form-array>
  }

  @if (config.type === customFormElements.richText) {
    <rich-text [group]="form" [config]="config" [direction]="direction">
    </rich-text>
  }

  @if (
    config.type === customFormElements.dropdownOther && form.get(config.prop)
  ) {
    <div>
      <dropdown-other [direction]="direction" [config]="config" [group]="form">
      </dropdown-other>
    </div>
  }

  @if (config.type === customFormElements.optionalDate) {
    <div>
      <optional-date [direction]="direction" [config]="config" [group]="form">
      </optional-date>
    </div>
  }

  @if (config.type === customFormElements.inputNA) {
    <div>
      <input-na
        [control]="form.get(config.prop)"
        [formControlName]="config.prop"
        [direction]="direction"
        [config]="config"
      >
      </input-na>
    </div>
  }

  @if (config.type === customFormElements.ssnMultiField) {
    <div>
      <ssn-multi-field
        [formControlName]="config.prop"
        [config]="config"
        [group]="form"
      >
      </ssn-multi-field>
    </div>
  }

  @if (config.type === customFormElements.speechRecognition) {
    <div>
      <speech-recognition
        [config]="config"
        [group]="form"
        [direction]="direction"
      ></speech-recognition>
    </div>
  }

  <div #registeredComponentContainer></div>
</div>
